import React, { useState } from 'react'
import { Button, Flex, Input, useToast } from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'
import ScoreService from '../../API/ScoreService'
import { useScoreStore } from '../../store/scoreStore'
import { toastWarning } from '../../utils/globalHelper'

function CollectingScoresComment({scoreData, pointData}) {
    const toast = useToast()
    const [comment, setComment] = useState(pointData?.comment || '')
    const [isLoading, setIsLoading] = useState(false)
    const updateComment = useScoreStore(state => state.updateComment)

    const saveComment = () => {
        const trimComment = comment.trim()

        if (!trimComment) {
            toast(toastWarning('Комментарий не может быть пустым'))
            return
        }

        toast.promise(
            ScoreService.updateScoreComment(
                scoreData.site_id,
                pointData.class_type_id,
                trimComment,
            ),
            {
                success: () => {
                    updateComment(scoreData.site_id, pointData.class_type_id, trimComment) 
                    setIsLoading(false)
                    return { title: "Комментарий обновлён" }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: "Не удалось обновить комментарий" }
                },
                loading: { title: "Обновление комментария...", position: 'top' }
            }
        )
    }

    return (
        <Flex gap='6px'>
            <Input
                bg={pointData?.tag?.title === 'другое' && !pointData?.comment && 'var(--chakra-colors-red-100)'}
                size='xs'
                minW='200px'
                value={comment}
                onChange={e => setComment(e.target.value)}
            />
            <Button
                size='xs'
                disabled={!comment || isLoading || pointData.comment === comment}
                onClick={saveComment}
            >
                <CheckIcon />
            </Button>
        </Flex>
    )
}

export default CollectingScoresComment
